import { DollarSign, Clock, Globe, Briefcase, Zap, Coffee, type LucideIcon } from "lucide-react"

export type JobDetail = {
  id: string
  title: string
  subtitle: string
  location: string
  type: string
  hours: string
  contract: string
  salary: string
  department: string
  description: string
  responsibilities: string[]
  requirements: string[]
  niceToHave: string[]
}

export type Benefit = {
  icon: LucideIcon
  title: string
  description: string
}

export const jobsData: Record<string, JobDetail> = {}

export const benefits: Benefit[] = [
  {
    icon: DollarSign,
    title: "Competitive Pay",
    description: "$5-15 USD/hour based on experience",
  },
  {
    icon: Clock,
    title: "Flexible Schedule",
    description: "Part-time or full-time (minimum 20h/week)",
  },
  {
    icon: Globe,
    title: "Remote-Friendly",
    description: "Work with a friendly, professional Vietnam-US team",
  },
  {
    icon: Briefcase,
    title: "Long-term Growth",
    description: "Opportunity for long-term collaboration and career advancement",
  },
  {
    icon: Zap,
    title: "Modern AI Tools",
    description: "Learn and work hands-on with cutting-edge AI development tools",
  },
  {
    icon: Coffee,
    title: "Fun Environment",
    description: "Fun, cooperative working environment with real impact",
  },
]
